import { CustomerFlagDto, ProcessStatusDto, TaskStatusDto } from '@/api/generated';

export type StatusTone =
  'accent' | 'danger' | 'neutral' | 'new' | 'progress' | 'success' | 'warning';

export const processStatusTone: Record<ProcessStatusDto, StatusTone> = {
  [ProcessStatusDto.Canceled]: 'neutral',
  [ProcessStatusDto.Created]: 'new',
  [ProcessStatusDto.Finished]: 'success',
  [ProcessStatusDto.InProgress]: 'progress',
};

export const taskStatusTone: Record<TaskStatusDto, StatusTone> = {
  [TaskStatusDto.Canceled]: 'neutral',
  [TaskStatusDto.Done]: 'success',
  [TaskStatusDto.DoneNotConfirmed]: 'accent',
  [TaskStatusDto.InProgress]: 'progress',
  [TaskStatusDto.New]: 'new',
  [TaskStatusDto.Postponed]: 'warning',
  [TaskStatusDto.Rejected]: 'danger',
};

export const customerFlagTone: Record<CustomerFlagDto, StatusTone> = {
  [CustomerFlagDto.Green]: 'success',
  [CustomerFlagDto.Red]: 'danger',
  [CustomerFlagDto.Yellow]: 'warning',
};

export const activityStatusTone = (status: string): StatusTone =>
  status === 'ACTIVE' ? 'success' : 'neutral';

export const isTaskFinished = (status: TaskStatusDto): boolean =>
  status === TaskStatusDto.Done ||
  status === TaskStatusDto.DoneNotConfirmed ||
  status === TaskStatusDto.Canceled ||
  status === TaskStatusDto.Rejected;

export const OPEN_TASK_STATUSES: TaskStatusDto[] = [
  TaskStatusDto.New,
  TaskStatusDto.InProgress,
  TaskStatusDto.Postponed,
  TaskStatusDto.DoneNotConfirmed,
];
